module.exports = __webpack_public_path__ + "static/media/Icono almacenamiento.f82b792b.svg";